<ng-container *ngIf="mostRecentEvents$ | async as mostRecentEvents">
    <ng-container *ngIf="mostRecentEvents">
        <div class="g-ui-grid-page most-recent-events-page">
            <div class="g-ui-grid-page__title">
                <app-heading level="h1" [text]="pageTexts.title"></app-heading>
            </div>

            <ng-container *ngFor="let chart of mostRecentEvents">
                <app-ag-chart *ngIf="!emptyState" (chartDataIsEmpty)="onChartEmpty()" [setChartParams]="chart"></app-ag-chart>
            </ng-container>

            <ng-container *ngIf="emptyState">
                <div class="empty-state">{{ emptyText }}</div>
            </ng-container>

        </div>
    </ng-container>
</ng-container>
